<template>
    <div class="alert alert-danger p-0 mb-0">
        <div class="d-flex align-items-center">
            <div class="warning-img" />
            <div class="fw-bold text-center">
                You are currently working in a live customer site as CP Admin. Be extra careful.
            </div>
            <div class="warning-img" />
        </div>
    </div>
</template>
<script>
    export default {
        props: {}
    };
</script>
<style lang="scss" scoped>
    .warning-img {
        background-image: url("Images/icons/caution.png");
        background-position: center;
        background-repeat: no-repeat;
        height: 5rem;
        min-width: 4rem;
        flex-grow: 1;
    }
</style>
